export class ModuleType {
  moduleTypeId: string;
  code: string;
  name: string;
  deleted: number;

  constructor(params: ModuleTypeParams) {
    this.moduleTypeId = params?.moduleTypeId;
    this.code = params?.code;
    this.name = params?.name;
    this.deleted = params?.deleted;
  }
}

interface ModuleTypeParams {
  moduleTypeId: string;
  code: string;
  name: string;
  deleted: number;
}
